import React, { KeyboardEvent, useEffect, useState } from 'react';
import clsx from 'clsx';
import { SearchFacetsResponse, SearchFacetsResponseBuckets } from '../../organisms/OSearchResults/store/store.type';
import {
  DefaultValue,
  SearchFacetsConstants,
  SearchFacetsList,
  SearchFacetsListCodes,
} from '../../organisms/OSearchResults/index.constant';
import { useConditionalPageContextSERP } from '../../hooks';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import {
  StyledPointsFilterDiv,
  StyledPointsContainerDiv,
  StyledHeaderContainerDiv,
  StyledPointsItemDiv,
  StyledPointsItemsContainerDiv,
  StyledPointsIncludeTaxesDiv,
} from './index.styles';
import { StyledPriceItemsContainerDiv, StyledPriceItemDiv } from '../MPriceFilters/index.styles';
import { renderedData } from '../../organisms/OSearchResults/searchResultsMainComponent';
import { PointsFiltersComponentsProps } from '../../organisms/OSearchResults/index.types';
import { RadioButton } from '@marriott/mi-ui-library';
import { useWindowSize } from '../../hooks';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/OSearchResults/lib/application.constants';
import { formatNumberByLocale } from '../../utils';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const PointsFilter: React.FC<PointsFiltersComponentsProps> = ({
  clearFilterState,
  allFilterPopUp,
  onItemSelect,
  jsonContents,
  onIncludeTaxesChange,
  onCurrencyUpdate,
  hideTaxesToggle,
  itemList,
}) => {
  const DEFAULT_POINTS_VALUE = DefaultValue;
  const currencyLimit = 7;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { sessionData, currentLocale } = useConditionalPageContextSERP();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const pointsVal = sessionData?.data?.AriesCommon?.ptsBal ?? sessionData?.cacheData?.data?.AriesCommon?.ptsBal;
  const jsonContentData = jsonContents ?? jsonContent;
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const showFullPriceInSession = sessionData?.cacheData
    ? sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.showFullPrice
    : sessionData?.data?.AriesSearch?.searchCriteria?.showFullPrice;
  const [isTaxesSliderActive, setIsTaxesSliderActive] = useState(
    showFullPriceInSession === 'true' || searchQueryState[SearchFacetsConstants.includeTaxes]
  );
  const [selectedCurrency, setSelectedCurrency] = useState(searchQueryState.currentCurrency);
  const [hideElement, setHideElements] = useState(
    allFilterPopUp ? currencyLimit : jsonContentData?.currencyListArray?.length
  );
  const clickTrackingLoc = 'Phoenix Search Results';

  const [currChecked, setCurrChecked] = useState<string | number | undefined>(DEFAULT_POINTS_VALUE);
  const getCurrPointsList = (): SearchFacetsResponse =>
    itemList
      ? itemList
      : searchQueryState?.filter?.filter(
          (key: SearchFacetsResponse) => key.type.code === SearchFacetsListCodes.points
        )[0];

  const [pointsList, setPointList] = useState<SearchFacetsResponse>(getCurrPointsList());
  const { width } = useWindowSize();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onPointsRangeChange = (pr: any): void => {
    setCurrChecked(pr);
    if (pr === DEFAULT_POINTS_VALUE) {
      onItemSelect(SearchFacetsList.points, {});
    } else {
      const str = typeof pr === 'number' ? String(pr) : pr;
      onItemSelect(SearchFacetsList.points, { [str]: pr });
    }
    setInteractionsSelected({ ...interactionsSelected, points: true });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleTaxesSelection = (event: any): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      onIncludeTaxesChange(!isTaxesSliderActive);
      setIsTaxesSliderActive(!isTaxesSliderActive);
    }
    setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const currencySetter = (event: any, currency: string): void => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      setSelectedCurrency(currency);
      onCurrencyUpdate(currency);
      // handleShowMoreLess(event, currency);
    }
    setInteractionsSelected({ ...interactionsSelected, currencyConversion: true });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleShowMoreLess = (event: any, currency: string): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      setHideElements(
        currency === 'less' && searchQueryState.currentCurrency === DefaultValue
          ? currencyLimit
          : jsonContentData?.currencyListArray?.length
      );
    }
  };

  useEffect(() => {
    if (clearFilterState === undefined || clearFilterState === null) {
      setCurrChecked(DEFAULT_POINTS_VALUE);
      setSelectedCurrency(DefaultValue);
      onCurrencyUpdate(DefaultValue);
      setIsTaxesSliderActive(false);
    }
  }, [clearFilterState]);

  useEffect(() => {
    setCurrChecked(Object.values(searchQueryState[SearchFacetsList.points] ?? {})[0] ?? DEFAULT_POINTS_VALUE);
  }, [searchQueryState[SearchFacetsList.points]]);

  useEffect(() => {
    setPointList(getCurrPointsList());
  }, [itemList]);

  useEffect(() => {
    if (allFilterPopUp) {
      setHideElements(
        searchQueryState.currentCurrency === DefaultValue ? currencyLimit : jsonContentData?.currencyListArray?.length
      );
    }
    onCurrencyUpdate(searchQueryState.currentCurrency);
  }, []);

  return (
    <StyledPointsFilterDiv>
      <StyledPointsContainerDiv className="t-label-alt-m">
        <StyledHeaderContainerDiv className="t-label-alt-m">
          {allFilterPopUp && (
            <div
              className={
                (width && width > BREAKPOINT_DESKTOP_1023
                  ? `t-subtitle-l`
                  : width && width > BREAKPOINT_TABLET
                  ? `t-subtitle-l`
                  : `t-font-m`) + ' filter-heading'
              }
            >
              {jsonContent.pointsLabel}
            </div>
          )}
        </StyledHeaderContainerDiv>
        {pointsVal ? (
          <h5
            className={clsx('t-subtitle-l', allFilterPopUp ? 'pt-4' : '', !allFilterPopUp ? 'pb-3 points-value' : '')}
          >
            {jsonContent.pointBalanceLabel}: {formatNumberByLocale(pointsVal, currentLocale)}
          </h5>
        ) : (
          ''
        )}
        <fieldset>
          <legend>
            <h6 className={'t-label-xs filter-sub-heading pb-2 ' + (allFilterPopUp ? 'pt-4' : '')}>
              {jsonContent?.totalPointsPerStayLabel?.toUpperCase()}
            </h6>
          </legend>
          <StyledPointsItemsContainerDiv key={1} className="hotel-points">
            <StyledPointsItemDiv className="points-item any-price" key="any-points-key-pr">
              <RadioButton
                radiobuttonName="points_radio"
                checked={currChecked === DEFAULT_POINTS_VALUE}
                customClickClass="radio-input custom_click_track"
                radiobuttonId="any-price-key-point"
                onChange={(): void => onPointsRangeChange(DEFAULT_POINTS_VALUE)}
                className="m-radio-button-m radio-container"
                {...{
                  custom_click_track_value: `${clickTrackingLoc}| ${jsonContent?.pointsLabel} Selection: ${jsonContent?.anyPointsLabel} |internal`,
                  tabIndex: -1,
                }}
                labelClassName="t-font-s col-12 item-name checkbox-radio"
                radiobuttonLabel={`${jsonContent?.anyPointsLabel}`}
                setTabIndex={0}
              ></RadioButton>
            </StyledPointsItemDiv>
            {pointsList?.buckets?.map((points: SearchFacetsResponseBuckets, idx: number) => {
              return (
                <StyledPointsItemDiv
                  className={`points-item ${points.count === 0 ? 'disabled' : ''}`}
                  key={`${points?.index}pr` + idx}
                >
                  <RadioButton
                    radiobuttonName="points_radio"
                    checked={currChecked === points?.index}
                    disabled={points?.count === 0}
                    customClickClass="t-font-alt-s radio-input custom_click_track"
                    radiobuttonId={`points_radio${idx}`}
                    onChange={(): void => onPointsRangeChange(points?.index)}
                    className="m-radio-button-sm t-font-alt-s radio-container"
                    {...{
                      custom_click_track_value: `${clickTrackingLoc}| ${jsonContent.pointsLabel} Range Selection: ${points?.start}-${points?.end} |internal`,
                      tabIndex: -1,
                    }}
                    labelClassName="t-font-s col-12 item-name checkbox-radio"
                    radiobuttonLabel={`${points?.start ? formatNumberByLocale(points?.start, currentLocale) : ''}${
                      points?.end === 'overflow'
                        ? '+'
                        : ` - ${points?.end ? formatNumberByLocale(points?.end, currentLocale) : ''}`
                    } ${points.count !== 0 ? `(${formatNumberByLocale(points?.count, currentLocale)})` : ''}`}
                    setTabIndex={0}
                  ></RadioButton>
                </StyledPointsItemDiv>
              );
            })}
          </StyledPointsItemsContainerDiv>
        </fieldset>
        {/* {allFilterPopUp ? <hr className="filter-separator" /> : ''} */}
      </StyledPointsContainerDiv>
      {hideTaxesToggle ? (
        <div />
      ) : (
        <StyledPointsIncludeTaxesDiv className="t-label-alt-m">
          <label
            className="include-taxes-and-fees-price-label t-font-s custom_click_track"
            htmlFor="include-taxes-and-fees-price"
            tabIndex={-1}
            {...{ custom_click_track_value: `${clickTrackingLoc}| Include Taxes & Fees |internal` }}
          >
            {jsonContentData?.filterTaxesLabel}
          </label>
          <label className="checkbox-switch-wrapper" htmlFor="include-taxes-and-fees-price">
            <span
              className="checkbox-switch"
              tabIndex={0}
              role="switch"
              aria-checked={isTaxesSliderActive}
              onKeyDown={(e): void => handleTaxesSelection(e)}
            >
              <input
                type="checkbox"
                id="include-taxes-and-fees-price"
                name="include-taxes-and-fees-price"
                checked={isTaxesSliderActive}
                onChange={(): void => {
                  onIncludeTaxesChange(!isTaxesSliderActive);
                  setIsTaxesSliderActive(!isTaxesSliderActive);
                }}
                tabIndex={-1}
                role="switch"
                aria-checked={isTaxesSliderActive}
                aria-label={jsonContentData?.filterTaxesLabel}
              />
              <span
                className="checkbox-slider custom_click_track"
                {...{ custom_click_track_value: `${clickTrackingLoc}| Include Taxes & Fees |internal` }}
              />
            </span>
          </label>
        </StyledPointsIncludeTaxesDiv>
      )}
      {false && (
        <fieldset>
          <legend>
            <h6 className="t-label-xs filter-sub-heading">{jsonContentData?.selectCurrencySubLabel}</h6>
          </legend>
          <StyledPriceItemsContainerDiv key={2} className="hotel-currency">
            <StyledPriceItemDiv className={`currency-item`} key={`${jsonContentData?.defaultLabel}prc`}>
              <RadioButton
                radiobuttonName="currency_radio"
                checked={selectedCurrency === DefaultValue}
                customClickClass="radio-input custom_click_track"
                radiobuttonId="currency_radio-any-currency"
                onChange={(): void => {
                  setSelectedCurrency(DefaultValue);
                  onCurrencyUpdate(DefaultValue);
                }}
                className="m-radio-button-m radio-container"
                {...{
                  custom_click_track_value: `${clickTrackingLoc}| Currency Selection: Default |internal`,
                  tabIndex: -1,
                  onKeyDown: (e: KeyboardEvent): void => {
                    currencySetter(e, DefaultValue);
                    onCurrencyUpdate(DefaultValue);
                  },
                }}
                labelClassName="t-font-s col-12 item-name checkbox-radio"
                radiobuttonLabel={jsonContentData?.defaultLabel}
                setTabIndex={0}
              ></RadioButton>
            </StyledPriceItemDiv>
            {jsonContentData?.currencyListArray
              ?.filter((_currency: Record<string, string>, index: number) => index < hideElement)
              ?.map((currency: Record<string, string>, idx: number) => {
                // const priceData = priceList.buckets.filter((priceD) => priceD.code === price.code)[0];
                return (
                  <StyledPriceItemDiv className={`currency-item`} key={`${currency?.['currencyTag']}prc`}>
                    <RadioButton
                      radiobuttonName="currency_radio"
                      checked={currency?.['currencyTag'] === selectedCurrency}
                      customClickClass="radio-input custom_click_track"
                      radiobuttonId={'currency_radio' + idx}
                      onChange={(): void => {
                        setSelectedCurrency(currency?.['currencyTag']);
                        onCurrencyUpdate(currency?.['currencyTag']);
                      }}
                      className="m-radio-button-m radio-container"
                      {...{
                        custom_click_track_value: `${clickTrackingLoc}| Currency Selection: ${currency?.['currencyTag']} |internal`,
                        tabIndex: -1,
                        onKeyDown: (e: KeyboardEvent): void => {
                          currencySetter(e, currency?.['currencyTag']);
                        },
                      }}
                      labelClassName="t-font-s col-12 item-name checkbox-radio"
                      radiobuttonLabel={currency?.['currencyTag']}
                    ></RadioButton>
                  </StyledPriceItemDiv>
                );
              })}
          </StyledPriceItemsContainerDiv>
        </fieldset>
      )}
      {allFilterPopUp ? (
        <>
          {false && (
            <div
              className="t-label-alt-xs show-more-less-option custom_click_track"
              role="button"
              onClick={(e): void => {
                handleShowMoreLess(e, hideElement <= currencyLimit ? 'more' : 'less');
              }}
              onKeyDown={(e): void => {
                e.stopPropagation();
                handleShowMoreLess(e, hideElement <= currencyLimit ? 'more' : 'less');
              }}
              {...{
                custom_click_track_value: `${clickTrackingLoc}| ${
                  hideElement <= currencyLimit ? jsonContentData.showLessLabel : jsonContentData.showMoreLabel
                } currency options |internal`,
              }}
              tabIndex={0}
              aria-label={`${
                hideElement <= currencyLimit ? jsonContentData.showMoreLabel : jsonContentData.showLessLabel
              }`}
            >
              {hideElement <= currencyLimit ? jsonContentData.showMoreLabel : jsonContentData.showLessLabel}
              <div className={hideElement <= currencyLimit ? 'icon-arrow-down' : 'icon-arrow-up'}></div>
            </div>
          )}
          <hr aria-hidden className="filter-separator" />
        </>
      ) : (
        ''
      )}
    </StyledPointsFilterDiv>
  );
};
